
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  QueueFirmwareRequest,
  RetrieveFirmwareResponseBody,
  SendFirmwareToDeviceResponseBody,
  UpdateMetadataRequestBody,
} from '../entities/remote-flash-v1/models';
import { GetFirmwareStatusRequest } from './types';
import { axiosInstance } from "../axios-instance";

class RemoteFlash {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getFirmwareStatus(
    input: GetFirmwareStatusRequest,
  ): Promise<AxiosResponse<RetrieveFirmwareResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<RetrieveFirmwareResponseBody>(`${this.baseUrl}/firmwareStatus`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  updateFirmwareMetadata(
    deviceKey: string,
    input: UpdateMetadataRequestBody,
  ): Promise<AxiosResponse<RetrieveFirmwareResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<RetrieveFirmwareResponseBody>(
      `${this.baseUrl}/firmwareMetadata/${deviceKey}`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      },
    );
  }

  queueFirmware(
    input: QueueFirmwareRequest,
  ): Promise<AxiosResponse<SendFirmwareToDeviceResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<SendFirmwareToDeviceResponseBody>(`${this.baseUrl}/queueFirmware`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }
}

export default RemoteFlash;
